import type { Leaves } from '@talos/kyoko';
import type { TradeSettlementColumn, TradeSettlementTreeColumn } from './types';

export const LP_SETTLEMENT_BLOTTER_PORTAL_ID = 'LpSettlementBlotterPortal';
export const UNSETTLED_TRANSACTIONS_BLOTTER_ID = 'lp-settlement/unsettled-transactions';

export const defaultUnsettledTransactionsTreeColumns: Leaves<TradeSettlementTreeColumn>[] = [
  'MarketAccount',
  'LegAsset',
  'subAccounts',
  'SettleStatus',
  'SettleDeadline',
  'EventTransactTime',
  'EventSide',
  'LegQuantity',
  'LegAmount',
  'LegDirection',
];

export const defaultUnsettledTransactionsColumns: Leaves<TradeSettlementColumn>[] = [
  'MarketAccount',
  'subAccounts',
  'SettleDeadline',
  'EventTransactTime',
  'EventSide',
  'BaseLeg.Quantity',
  'QuoteLeg.Amount',
];
